<h4 mat-dialog-title>{{data.version}}</h4>
<button type="button" class="btn btn-link fal fa-times close" mat-dialog-close aria-label="Close"></button>
<div mat-dialog-content>
    <video *ngIf="data.src" class="item-block--video" width="100%" controls (play)="countView(data)"  controlsList="nodownload" (ended)="viewed = false;" appNoRightClick>
        <source [src]="data.src" type="video/mp4">
        Your browser does not support the video tag.
    </video>
    <div *ngIf="data.description" class="info-text" [innerHTML]="data.description"></div>
</div>
